import { render } from "./accountCategoryReferences.vue?vue&type=template&id=011e5f52"
import script from "./accountCategoryReferences.vue?vue&type=script&lang=js"
export * from "./accountCategoryReferences.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__